var plus15 = 0
var ua = navigator.userAgent;
var regexpFF = /Firefox/;
var regexpCH = /Chrome/;
var regexpOP = /Opera/;
var regexpIE = /MSIE/;
if (regexpFF.test(ua)) {
  Navigateur = 'Firefox';
}
else if (regexpCH.test(ua)) {
  Navigateur = 'Chrome';
}
else if (regexpOP.test(ua)) {
  Navigateur = 'Opera';
}
else if (regexpIE.test(ua)) {
  Navigateur = 'Explorer';
}
else Navigateur = 'Default';
//  console.log(Navigateur);
if ( Navigateur == 'Chrome'){
  plus15 = 15;
}

var windowWidth = $(window).width() + plus15;
url = window.location.href;

$(document).ready(function(){
  
});
